import * as React from "react";
import { DisplayBookOfMind } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Display/DisplayBookOfMind";
import { BannerImages } from "source/app/services/Shared/RenderSwal/BannerImage/BannerImage";
import RenderSwal from "source/app/services/Shared/RenderSwal/RenderSwal";
import { Sounds } from "source/app/services/Sound/Sounds";
import { ETexture } from "source/app/services/UI/Background/Texture/ETexture";
import { Texture } from "source/app/services/UI/Background/Texture/Texture";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IWorkflowsState } from "../IWorkflowsState";
import { bookOfMindSpeech } from "./Speech/BookOfMindSpeech";
import { ClearBookOfMindNodeIndex } from "./Helpers/BookOfMindNodeIndex";

export function BookOfMind(rootNodeName: string) {
    const haveWorkflowsLoaded =
        State.ReadClass<IWorkflowsState>(ESharedComponent.Workflows) !==
        undefined;

    if (!haveWorkflowsLoaded) {
        return;
    }

    Sounds.paper_long_flip.Play();

    const backgroundTexture = new Texture({
        image: ETexture.groovepaper,
        backgroundColor: { h: 34, s: 14, l: 9, a: 1 },
    }).combinedCSS.background as string;

    RenderSwal(
        {
            bannerImage: BannerImages.waxTablet,
            backgroundFadeInDurationInMilliseconds: 650,
            background: `radial-gradient(
                ellipse at 24% 12%,
                rgba(150, 111, 48, 0.13) 0%,
                rgba(86, 61, 24, 0.07) 30%,
                transparent 61%
            ), radial-gradient(
                ellipse at 78% 76%,
                rgba(91, 62, 24, 0.1) 0%,
                rgba(35, 25, 12, 0.06) 38%,
                transparent 66%
            ), linear-gradient(
                118deg,
                rgba(255, 220, 151, 0.025) 0%,
                transparent 34%,
                rgba(0, 0, 0, 0.12) 100%
            ), radial-gradient(
                ellipse at center,
                transparent 48%,
                rgba(0, 0, 0, 0.2) 100%
            ), ${backgroundTexture}`,
            maxWidth: `600px`,
            columnCount: 1,
            height: `65vh`,
            showButtonDivider: true,
            buttonDividerHeight: `56px`,
            buttonDividerButtonsAtBottom: true,
            contentTopFade: true,
            contentTopFadeHeight: `44px`,
            contentBottomFade: true,
            contentBottomFadeHeight: `44px`,
            onAfterClose: () => {
                bookOfMindSpeech.StopNoSleep();
                ClearBookOfMindNodeIndex();
            },
        },
        <DisplayBookOfMind {...{ rootNodeName }} />,
        () => {
            bookOfMindSpeech.StopNoSleep();
        }
    );
}
